import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  AmountContainer,
  AmountText,
  DepositContainer,
  Price,
  PriceContainer,
} from './style'
import { useAppSelector } from '../../../store/hooks'

type Props = {
  totalPrice: number
  isShowPrice: boolean
  totalDeposit: number
  isShowDeposit: boolean
}

export const TotalPrice = ({
  totalPrice,
  isShowPrice,
  totalDeposit,
  isShowDeposit,
}: Props) => {
  const { t } = useTranslation()
  const settings = useAppSelector((state) => state.settings.values)  

  if (!isShowPrice && !isShowDeposit) {
    return null
  }

  return (
    ((isShowPrice && totalPrice !== 0) || (isShowDeposit && totalDeposit !== 0)) && 
    (<PriceContainer data-component="price-container" fontColor={settings.fontColor}>
      {isShowPrice && totalPrice !== 0 && (
        <AmountContainer>
          <AmountText fontColor={settings.fontColor}>{t('Total amount')} : </AmountText>
          <Price fontColor={settings.fontColor}>&euro; {totalPrice.toFixed(2)}</Price>
        </AmountContainer>
      )}
      {isShowDeposit && totalDeposit !== 0 && (
        <DepositContainer hasMarginTop={isShowPrice && totalPrice !== 0}>
          <AmountText fontColor={settings.fontColor}>{t('Total deposit')} : </AmountText>
          <Price fontColor={settings.fontColor}>&euro; {totalDeposit.toFixed(2)}</Price>
        </DepositContainer>
      )}
    </PriceContainer>)
  )
}
